export const getDropdownFilterGrid = () => {
    return {
        i18n: "installationoverview.grid",
        label: "Grid",
        id: "grid",
        options: [
            {
                type: "minMax",
                i18n: "installationoverview.grid",
                label: "Grid",
                variable: "grid",
                min: "",
                max: "",
                measure: "watt" // used with class ::before
            }
        ]
    };
};